module.exports = __webpack_public_path__ + "img/materials_analysis_2.bc887ef7.png";